import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/question_types');
  return response.data.data;
}

export default {
  index,
};
